import { ToastContainer } from 'react-toastify';
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { FormLayout, FormWizard } from "../../../Constant";
import NumberingWizard from "./NmberingWizard";
import VerticalValidationWizard from "./VerticalValidationWizard";
import StudentValidationForm from './StudentValidationForm';
import ShippingForm from './ShippingForm';

const FormWizardOneContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={FormWizard} parent={FormLayout} title={FormWizard} />
      <Container fluid>
        <Row>
          <NumberingWizard />
          <StudentValidationForm />
          <VerticalValidationWizard/>
          <ShippingForm />
        </Row>
      </Container>
      <ToastContainer/>
    </>
  );
};

export default FormWizardOneContainer;
